var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.isAgGridProductListEnabled && _vm.showGrid
        ? _c("grid-view-ag-grid", {
            ref: "agGridComponent",
            attrs: {
              "level-entry-key": _vm.levelEntryKey,
              "is-unit-manager-view": _vm.isUnitManagerView,
              "tension-chart-options": _vm.tensionChartOptions,
            },
            on: {
              downloadData: function ($event) {
                return _vm.downloadDataHandler($event)
              },
              toggleFilteringByArchitectureGroup:
                _vm.onToggleFilteringByArchitectureGroup,
            },
          })
        : _vm._e(),
      _vm._v(" "),
      !_vm.isAgGridProductListEnabled
        ? _c("grid-view", {
            ref: "gridViewComponent",
            attrs: {
              headers: _vm.headers,
              items: _vm.filteredItems,
              "level-entry-key": _vm.levelEntryKey,
              "is-unit-manager-view": _vm.isUnitManagerView,
              "architecture-group-description-to-color-map":
                _vm.architectureGroupDescriptionToColorMap,
              "architecture-sub-group-description-to-color-map":
                _vm.architectureSubGroupDescriptionToColorMap,
              "tension-chart-options": _vm.tensionChartOptions,
            },
            on: {
              downloadData: function ($event) {
                return _vm.downloadDataHandler($event)
              },
              toggleFilteringByArchitectureGroup:
                _vm.onToggleFilteringByArchitectureGroup,
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }